/**
 * @module dateFormats
 * @description A list of dateFormats
 */

export const dateFormats = [
	'yyyy-MM-dd',
	'MM/dd/yyyy',
	'd.m.y',
	'Y-m-d',
	'MM/DD/YYYY h:mm a',
] as const;
export type DateFormats = (typeof dateFormats)[number];
